module.exports = __webpack_public_path__ + "img/por-que-ser-um-licenciado.67204082.jpg";